import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  findAllCustomer,
  insertCustomer,
  updateCustomer,
  deleteCustomer,
  findByIDCustomer,
  findAllActiveCustomer,
  activeInActiveCustomer,
  findPendingCartCustomerList,
} from "./customer.service";
import { ICustomer, ICustomerDetails, IPendingCartCustomer } from "./customerModel";

export interface ICustomerState {
  loading: boolean;
  error: string;
  CustomerID: null | number;
  CustomerList: ICustomer[];
  CustomerDetail: ICustomerDetails;
  isDeleteModalOpen: boolean;
  DeleteCustomerID: number | null;
  PendingCartCustomerList: IPendingCartCustomer[];
  pendingCartLoading: boolean;
  pendingCartError: string;
}

const initialState: ICustomerState = {
  loading: false,
  error: "",
  CustomerList: [],
  CustomerID: null,
  CustomerDetail: {
    ID: null,
    FullName: "",
    EmailID: "",
    MobileNo: "",
    BusinessName: "",
    CustomerType: [],
    Password: "",
    Address: "",
    Pincode: "",
    GSTNo: "",
    IsActive: true,
  },
  isDeleteModalOpen: false,
  DeleteCustomerID: null,
  PendingCartCustomerList: [],
  pendingCartLoading: false,
  pendingCartError: "",
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    clearCustomerDetails: (state) => {
      state.CustomerDetail = initialState.CustomerDetail;
    },
    setCustomerID: (state, action) => {
      state.CustomerID = action.payload;
    },
    clearCustomerID: (state) => {
      state.CustomerID = initialState.CustomerID;
    },
    openDeleteModal: (state, action: PayloadAction<number>) => {
      state.DeleteCustomerID = action.payload;
      state.isDeleteModalOpen = true;
    },
    closeDeleteModal: (state) => {
      state.isDeleteModalOpen = false;
      state.DeleteCustomerID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllCustomer.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      findAllCustomer.fulfilled,
      (state, action: PayloadAction<ICustomer[]>) => {
        state.loading = false;
        state.CustomerList = action.payload || [];
        state.error = "";
      },
    );
    builder.addCase(findAllCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CustomerList = [];
    });
    builder.addCase(insertCustomer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertCustomer.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateCustomer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateCustomer.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(findByIDCustomer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findByIDCustomer.fulfilled, (state, action: any) => {
      state.loading = false;
      state.CustomerDetail = action.payload;
    });
    builder.addCase(findByIDCustomer.rejected, (state, action) => {
      state.loading = false;
      state.CustomerDetail = initialState.CustomerDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteCustomer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCustomer.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(findAllActiveCustomer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllActiveCustomer.fulfilled,
      (state, action: PayloadAction<ICustomer[]>) => {
        state.loading = false;
        state.CustomerList = action.payload || [];
      },
    );
    builder.addCase(findAllActiveCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CustomerList = [];
    });
    builder.addCase(activeInActiveCustomer.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInActiveCustomer.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInActiveCustomer.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(findPendingCartCustomerList.pending, (state) => {
      state.pendingCartLoading = true;
      state.pendingCartError = "";
    });
    builder.addCase(
      findPendingCartCustomerList.fulfilled,
      (state, action: PayloadAction<IPendingCartCustomer[]>) => {
        state.pendingCartLoading = false;
        state.PendingCartCustomerList = action.payload || [];
        state.pendingCartError = "";
      },
    );
    builder.addCase(findPendingCartCustomerList.rejected, (state, action) => {
      state.pendingCartLoading = false;
      state.pendingCartError = action.error.message || "Something went wrong";
      state.PendingCartCustomerList = [];
    });
  },
});

export const {
  clearCustomerDetails,
  setCustomerID,
  clearCustomerID,
  openDeleteModal,
  closeDeleteModal,
} = customerSlice.actions;
export default customerSlice.reducer;
